import React from 'react';

const AdminSection = (props) => {
  return (
    <section className={`AdminSection ${props.title ? `border` : ""}`}>  
      {props.title 
      ? <h3 className="title">{props.title}</h3>
      : ""}
      
      {props.children}
    </section>
  );
}

export default AdminSection;